export class AuthQueryParams {
    public static readonly STEP_QUERY_PARAM: string = 'step';
    public static readonly IGNORE_DOMAIN_AUTOLOGIN: string = 'ignoreDomainUserAutoLogin';
    public static readonly IGNORE_AUTOLOGIN: string = 'ignoreAutoLogin';
    public static readonly RETURN_URL_PARAM: string = 'ReturnUrl';
    public static readonly AUTH_KEY: string = '11e1013bf15c4cfe83902944b9dff139';
}